export class Dialog {
    constructor() {
        this.isConfirmBind = false;
    }
    confirm(option) {
        if (!this.$confirmEl) {
            this.initConfirm();
        }
        this.$confirmEl.find('.x_title').text(option.title)
            .show();
        if (option.desc) {
            this.$confirmEl.find('.x_desc').text(option.desc).show();
        }
        else {
            this.$confirmEl.find('.x_desc').hide();
        }
        this.$confirmEl.fadeIn();
        const p = new Promise(r => this.resolve = r);
        if (!this.isConfirmBind) {
            this.$confirmEl.on('click', '.isCancel', () => {
                this.resolve({ isOK: false });
                this.$confirmEl.fadeOut();
            });
            this.$confirmEl.on('click', '.x_close', () => {
                this.resolve({ isOK: false });
                this.$confirmEl.fadeOut();
            });
            this.$confirmEl.on('click', '.isOk', () => {
                this.resolve({ isOK: true });
                this.$confirmEl.fadeOut();
            });
            this.isConfirmBind = true;
        }
        return p;
    }
    initConfirm() {
        const $df = $(document.createDocumentFragment());
        $df.append(`
        <div class="x_modal" id="x_comfirm" style="display:none">
        <!--[if IE]><iframe src="about:blank" frameborder="0" class="x_iframe_mask"></iframe><![endif]-->
        <div class="x_modal_bd">
            <a href="javascript:;" class="x_close" title="关闭"><i class="x_iconfont x_icon_close"></i></a>
            <div class="x_icon_line"><i class="x_iconfont x_icon_warning"></i></div>
            <h3 class="x_title">确定取消关注吗?</h3>
            <div class="x_desc">取消后不再接收该兴趣点更新信息</div>
        </div>
        <div class="x_modal_ft">
            <a class="x_btn isCancel" href="javascript:;">取消</a>
            <a class="x_btn x_btn_primary isOk" href="javascript:;">确定</a>
        </div>
    </div>
        `);
        this.$confirmEl = $df.children('#x_comfirm');
        this.$confirmEl.appendTo(document.body);
    }
}
export const dialog = new Dialog();
